import type { CreatorInfoAddressDto, CreatorProfileDto, GetInforOnboardingDto, RandomWishListItemDto } from './dtos/onboarding-step/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { OnboardingStep } from '../users/onboarding-step.enum';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  apiName = 'Default';
  

  addGiftForLinkByInput = (input: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'POST',
      url: '/api/app/onboarding/gift-for-link',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getInforOnboarding = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, GetInforOnboardingDto>({
      method: 'GET',
      url: '/api/app/onboarding/infor-onboarding',
    },
    { apiName: this.apiName,...config });
  

  getRandomWishListItemsByCount = (count: number = 10, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RandomWishListItemDto[]>({
      method: 'GET',
      url: '/api/app/onboarding/random-wish-list-items',
      params: { count },
    },
    { apiName: this.apiName,...config });
  

  updateOnboardingStepByOnboardingStep = (onboardingStep: OnboardingStep, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'PUT',
      url: '/api/app/onboarding/onboarding-step',
      params: { onboardingStep },
    },
    { apiName: this.apiName,...config });
  

  updateStepAddress = (input: CreatorInfoAddressDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'PUT',
      url: '/api/app/onboarding/step-address',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateStepProfile = (input: CreatorProfileDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'PUT',
      url: '/api/app/onboarding/step-profile',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
